export enum SubscriptionStatus {
    ACTIVE = 1,
    NON_ACTIVE = 2,
}
